import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=2bd5a73a&scoped=true"
import script from "./nav.vue?vue&type=script&lang=ts"
export * from "./nav.vue?vue&type=script&lang=ts"
import style0 from "./nav.vue?vue&type=style&index=0&id=2bd5a73a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5a73a",
  null
  
)

export default component.exports